import { Skeleton } from "@/core/components/ui/skeleton";

/** Skeleton que ocupa o espaço do banner da Lia enquanto o estado do card de excedente carrega. */
export function DashboardBannerIASkeleton() {
  return (
    <div className="rounded-lg border border-border bg-card p-4 min-h-[120px] flex gap-3">
      <Skeleton className="w-14 h-14 rounded-full shrink-0" />
      <div className="flex-1 space-y-2">
        <Skeleton className="w-48 h-5 rounded" />
        <Skeleton className="w-full max-w-md h-4 rounded" />
        <Skeleton className="w-3/4 max-w-sm h-4 rounded" />
        <Skeleton className="mt-2 w-40 h-9 rounded-lg" />
      </div>
    </div>
  );
}
